import React, { useEffect } from 'react';
import useAxios from 'axios-hooks';
import { AxiosError } from 'axios';
import bridge from '@vkontakte/vk-bridge';
import { Alias } from 'types';

interface UseGetAliasByVkParamsProps {
  alias?: string;
  setAlias: React.Dispatch<React.SetStateAction<string>>;
  searchParams: {
    [k: string]: string;
  };
}

interface UseGetAliasByVkParamsReturn {
  vkError?: AxiosError<unknown>;
  vkDataLoading: boolean;
  isShowVKGroupConnectPage: boolean;
  isBookingFromVk: boolean;
}

export const useGetAliasByVkParams = ({
  alias,
  setAlias,
  searchParams,
}: UseGetAliasByVkParamsProps): UseGetAliasByVkParamsReturn => {
  const vkGroupId = searchParams.vk_group_id;
  const isVkParamsPresent = !!searchParams.vk_app_id;

  // Проверка переданных параметров VK
  const [
    {
      data: vkParamsValid,
      loading: vkParamsValidLoading,
      error: vkParamsNotValidError,
    },
  ] = useAxios(
    {
      url: '/booking-widget/client/vk/validate',
      method: 'POST',
      data: searchParams,
    },
    { manual: !!alias || !isVkParamsPresent },
  );

  const isVkParamsValid = typeof vkParamsValid !== 'undefined';

  // Инициализация миниапп VK
  useEffect(() => {
    if (isVkParamsValid) {
      bridge.send('VKWebAppInit');
    }
  }, [isVkParamsValid]);

  // Получение alias виджета по vkGroupId
  const [
    {
      data: aliasByVKGroupId,
      loading: aliasByVKGroupIdLoading,
      error: aliasByVKGroupIdError,
    },
  ] = useAxios<Alias>(
    {
      url: `/booking-widget/client/vk/${vkGroupId}`,
    },
    { manual: !(isVkParamsValid && vkGroupId) },
  );

  useEffect(() => {
    if (!alias && aliasByVKGroupId) {
      setAlias(aliasByVKGroupId.alias);
    }
  }, [alias, aliasByVKGroupId, setAlias]);

  return {
    vkDataLoading: vkParamsValidLoading || aliasByVKGroupIdLoading,
    vkError: vkParamsNotValidError || aliasByVKGroupIdError,
    isShowVKGroupConnectPage: isVkParamsValid && !vkGroupId,
    isBookingFromVk: !!aliasByVKGroupId,
  };
};
